import React, {
  useContext, useMemo, useState, useEffect,
} from 'react';
import moment from 'moment';
import classnames from 'classnames';

import './styles.scss';
import { useTranslation } from '@common/hooks/translation';
import { RacingsContext } from '@racings/store/context';
import { useParams } from 'react-router';

export const Filter = () => {
  const [racingState, setRacingsState] = useContext(RacingsContext);
  const { dateFilter } = racingState;
  const [active, setActive] = useState('Today');
  const t = useTranslation();

  const { sportType, regionId } = useParams();

  useEffect(() => {
    setRacingsState((old) => ({ ...old, dateFilter: moment(new Date()).unix(), id: '' }));
  }, [sportType, setRacingsState, regionId]);

  const items = useMemo(() => {
    let now = moment(new Date());
    const dateFitlerDate = moment.unix(dateFilter);
    now = now.date() === dateFitlerDate.date() ? dateFitlerDate : now;

    const list = [
      {
        type: 'date',
        label: 'Today',
        value: now.unix(),
      },
      {
        type: 'date',
        label: 'Tomorrow',
        value: now.add(1, 'days').unix(),
      },
      {
        type: 'date',
        label: now.add(1, 'days').format('DD/MM'),
        value: now.unix(),
      },
      {
        type: 'date',
        label: now.add(1, 'days').format('DD/MM'),
        value: now.unix(),
      },
    ];

    if (sportType === 'horse-racing') {
      list.push(
        {
          label: 'future races',
          id: 180,
        },
        {
          label: 'specials',
          id: 153,
        },
      );
    }
    return list;
  }, [sportType]);

  return (
    <div className="date-filter-container">
      {items.map((item) => (
        <div
          key={item.label}
          onClick={() => {
            setActive(item.label);
            setRacingsState({ ...racingState, dateFilter: item.value, id: item.id || '' });
          }}
          className={classnames('filter-item', {
            active: item.label === active,
          })}
        >
          {t(item.label)}
        </div>
      ))}
    </div>
  );
};
